<template>
    <ModalContainer :visible="visible" :loading="loading">
        <template v-slot:header>
            <div class="margin-bottom-10">
                <button type="button" class="close" @click="$emit('close-add-video-showcase-modal')"><i class="las la-times"></i></button>
                <h4 class="modal-title">{{$t('components.showcase_add_videos_modal.title')}}</h4>
            </div>
            <div class="input-group hide">
                <input type="text" class="form-control">
                <span class="input-group-btn">
                    <button class="btn btn-primary" type="button"><i class="las la-search"></i></button>
                </span>
            </div>
        </template>
        <template v-slot:body>
            <div v-if="videos.length > selectedVideosProp.length" style="max-height:400px;overflow-y:scroll;margin:-16px 0px -15px 0px;">
                <table class="table" >
                    <tbody>
                        <tr v-for="video in videos" v-bind:key="video.id" v-show="!selectedVideosProp.includes(video.id)">
                            <td width="1">
                                <div class="checkbox">
                                    <label>
                                        <input type="checkbox" :value="video.id" v-model="selectedVideos">
                                    </label>
                                </div>
                            </td>
                            <td width="101"><img class="img-rounded img-responsive" :src="'https://i.vimeocdn.com/video/' + video.picture_id + '-' + video.picture_key +'-d_300x180'"></td>
                            <td>
                                <h5 class="margin-bottom-5">{{video.title}}</h5>
                                <span class="text-muted">{{getDataExtendString(video.created_date)}}</span>
                            </td>
                            <td class="text-right">
                                <i class="las la-stopwatch"></i> {{getDurationTime(video.duration)}}
                            </td>

                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-else class="alert alert-info" role="alert">
                {{ $t('views.videos.not_found') }}
            </div>
        </template>

        <template v-slot:footer>
            <button class="btn btn-default pull-left" @click="$emit('close-add-video-showcase-modal')">{{$t('common.cancel')}}</button>
            <button v-if="videos.length > selectedVideosProp.length" class="btn btn-primary" @click="saveAddVideosClick">{{$t('components.showcase_add_videos_modal.button_add_videos')}}</button>
        </template>
    </ModalContainer>
</template>

<script>
import ModalContainer from "./ModalContainer";
import {getAllVideos, patchVideosInShowcase} from "../../api";
import {Utils} from "../../common/utils";
import i18n from '../../i18n'


export default {
    name: "AddVideoShowcaseModal",
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        selectedVideosProp: {
            type: Array,
            required: true
        },
        showcaseId: {
            type: Number,
            required: true
        }
    },
    mounted() {
        this.getAllVideos();
        this.selectedVideos = this.selectedVideosProp;
    },
    data: () => {
        return {
            loading: false,
            errorMessage:"",
            videos: [],
            selectedVideos: []
        }
    },
    components: {ModalContainer},
    methods: {
        async getAllVideos() {
            this.loading = true;
            try {
                this.videos = await getAllVideos();
                this.loading = false;
            } catch (e) {
                this.loading = false;
                console.log(e)
            }
        },
        async saveAddVideosClick() {
            this.loading = true;
            try {
                await patchVideosInShowcase(
                    this.showcaseId,
                    this.selectedVideos,
                );

                this.loading = false;
                this.$route.params.successMessage = i18n.t('components.showcase_add_videos_modal.add_videos_success');
                this.$emit('success-add-video-showcase-modal')
            } catch (e) {
                this.loading = false;
                console.log(e)
            }
        },
        getDataExtendString(date){
            return Utils.getDateStringFromISO(date)
        },
        getDurationTime(seconds) {
            return Utils.getDurationTime(seconds)
        },
    },
    watch: {
        selectedVideosProp: function (newVal) {
            this.selectedVideos = newVal;
        }
    }
};
</script>
